/**
 * Consent-Manager — zentrale Quelle für Tracking-Einwilligung (DSGVO).
 *
 * Werte: 'granted' | 'denied' | null (null = noch keine Entscheidung)
 *
 * API:
 *   getConsent()          → aktueller Wert
 *   setConsent(v)         → speichert + feuert alle Listener
 *   onConsentChange(cb)   → cb(newValue) bei Änderung; gibt unsubscribe() zurück
 *   resetConsent()        → löscht Einwilligung (für Widerruf-UI)
 */

const STORAGE_KEY = 'cvflow_consent_v1';

const listeners = new Set();

export function getConsent() {
  return localStorage.getItem(STORAGE_KEY); // 'granted' | 'denied' | null
}

export function setConsent(value) {
  if (value !== 'granted' && value !== 'denied') return;
  localStorage.setItem(STORAGE_KEY, value);
  listeners.forEach((cb) => cb(value));
}

export function resetConsent() {
  localStorage.removeItem(STORAGE_KEY);
  listeners.forEach((cb) => cb(null));
}

/**
 * Registriert einen Listener für Consent-Änderungen.
 * Gibt eine unsubscribe-Funktion zurück.
 */
export function onConsentChange(cb) {
  listeners.add(cb);
  return () => listeners.delete(cb);
}
